import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import Button from 'material-ui/Button';
import * as getAPIVersion from '../../actions/lookup'


class Footer extends React.Component {

    componentDidMount() {
        this.props.actions.getAPIVersion();
    }

    render() {
//const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <div>
                        {/* <span> RareTech WLL &copy; 2018</span> */}

                        <span> © {new Date().getFullYear()}<img className="footer-logo" src="alpha-logo.svg" />Alpha Meeting++</span>
                        
                    </div>
                    <div style={{ textAlign: 'right' }}>
                    <span style={{ textAlign: 'right' }}>{this.props.getAddUserRoleLookup.apiVersionInfo?'v-'+this.props.getAddUserRoleLookup.apiVersionInfo.version:''} </span>
                    </div>
                </div>
            </footer>
        );
    };
}

const mapStateToProps = ({ getAddUserRoleLookup }) => {
    return { getAddUserRoleLookup }
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, getAPIVersion), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
//export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js